import {baseURL} from '@/infrastructure/Configuration'
import SessionApi from "@/mixins/Services/SessionApi";
import Utils from "@/mixins/Utils";

const COMPANY = 'company/';
const ADMIN_COMPANY = 'admin/company/';
const NODE = '/node';
const QUEUE = '/queue-relations';
const QUEUES = '/queues';

export default {
    mixins: [SessionApi, Utils],
    methods: {
        async getNodes() {
            const url = `${baseURL}${COMPANY}${this.loadCompanyId()}${NODE}`
            const response = await this.httpSession().get(url)
            console.debug('[NODOS][getNodes] RESPONSE', response.data)
            return response.data;
        },

        async createNode(data) {
            console.debug('[NODOS][createNode] request data', data)
            const url = `${baseURL}${ADMIN_COMPANY}${this.loadCompanyId()}${NODE}`
            const response = await this.httpSession().post(url, {...data})
            console.debug('[NODOS][createNode] RESPONSE', response.data)
            return response.data
        },

        async updateNode(data) {
            console.debug('[NODOS][updateNode] request data', data)
            const url = `${baseURL}${ADMIN_COMPANY}${this.loadCompanyId()}${NODE}/${data.id}`
            const response = await this.httpSession().put(url, {...data})
            console.debug('[NODOS][updateNode] RESPONSE', response.data)
            return response.data
        },

        async deleteNode(nodeId) {
            console.debug('[NODOS][deleteNode] request nodeId', nodeId)
            const url = `${baseURL}${ADMIN_COMPANY}${this.loadCompanyId()}${NODE}/${nodeId}`
            const response = await this.httpSession().delete(url)
            console.debug('[NODOS][deleteNode] RESPONSE', response.data)
            return response.data
        },

        async importCSV(data) {
            console.debug('[NODOS][importCSV] request data', data)
            let formData = new FormData();
            formData.append("file", data);
            const url = `${baseURL}${ADMIN_COMPANY}${this.loadCompanyId()}${NODE}/import`
            const response = await this.httpSession().post(url, formData)
            console.debug('[NODOS][importCSV] RESPONSE', response.data)
            return response.data
        },

        async getAgentsByQueue() {
            const url = `${baseURL}${COMPANY}${this.loadCompanyId()}${NODE}${QUEUE}`
            const response = await this.httpSession().get(url)
            console.debug('[NODOS][getAgentsByQueue] RESPONSE', response.data?.queues)
            return response.data?.queues;
        },

        async getQueuesByCompany() {
            const url = `${baseURL}${COMPANY}${this.loadCompanyId()}${NODE}${QUEUES}`
            const response = await this.httpSession().get(url)
            console.info('[NODOS][getQueuesByCompany] RESPONSE', response.data)
            return response.data;
        },
    },
};
